<template>
  <section class="categories">
    <h1>Categorieën</h1>
    <ul v-if="!defaultPrintStore">
      <li v-for="category in categories" :key="category.id">
        <!--  <router-link
          :to="{
            name: 'printStoreCategory',
            params: { categoryId: category.id }
          }"
          class="main-menu-item"
          :class="{ active: $route.params.categoryId === category.id }"
        >
          {{ category.name }}
        </router-link> -->
        <router-link
          :to="{
            name: 'printStoreCategory',
            params: { categoryId: category.id }
          }"
          class="main-menu-item"
          :class="{
            active: $route.params.categoryId === category.id,
            hidden: !category.active
          }"
          :style="
            buttonStyle(
              category.colour ? category.colour : printStoreColor,
              $route.params.categoryId === category.id
            )
          "
        >
          {{ category.name }}
        </router-link>
      </li>
    </ul>
    <ul>
      <li v-for="category in defaultCategories" :key="category.id">
        <router-link
          :to="{
            name: 'printStoreCategory',
            params: { categoryId: category.id }
          }"
          class="main-menu-item"
          :class="{ active: $route.params.categoryId === category.id }"
        >
          {{ category.name }}
        </router-link>
      </li>
    </ul>
  </section>
</template>

<script>
import PrintStoreMixin from '../PrintStoreMixin'
import { mapStores } from 'pinia'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'

export default {
  mixins: [PrintStoreMixin],
  methods: {
    buttonStyle(color, active) {
      let psColor = color || this.printStoreStore.theme.subColor

      if (active) {
        return {
          'background-color': psColor,
          color: 'white',
          'border-color': psColor
        }
      } else {
        return {
          color: psColor,
          'border-color': psColor
        }
      }
    },
    setCatsList(cats) {
      let catsList = [...cats]

      if (
        !this.printStoreStore.loggedIn ||
        this.printStoreStore.user.printStore.role !== 'ADMIN'
      ) {
        catsList = catsList.filter((cat) => cat.active)
      }

      for (let i = 0; i < catsList.length; i++) {
        if (catsList[i].listOnTop) {
          const toTop = catsList[i]
          catsList.splice(i, 1)
          catsList.unshift(toTop)
        }
      }

      return catsList
    }
  },
  computed: {
    ...mapStores(usePrintStoreStore),
    categories() {
      return this.setCatsList(this.printStoreStore.categories)
    },
    defaultCategories() {
      return this.hideRijnjaContent
        ? []
        : this.setCatsList(this.printStoreStore.defaultCategories)
    },
    defaultPrintStore() {
      return this.rootStore.theme.printStore.isDefault
    }
  }
}
</script>

<style lang="scss" scoped>
.categories {
  padding: 0 21px;
  margin: 15px 0;
}
h1 {
  font-size: 19px;
  font-weight: 500;
  margin-bottom: 10px;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0 -6px;
  display: flex;
  flex-wrap: wrap;

  //flex-direction: column;
}

li {
  margin: 6px 4px;
  a {
    display: inline-block;
    background-color: #fff;
    color: var(--sub-color);
    border-radius: 18px;
    padding: 0px 15px;
    line-height: 30px;
    text-decoration: none;
    font-weight: 500;
    font-size: 12px;
    transition: all 0.25s;
    border: 2px solid var(--sub-color);

    &.active {
      color: white;
      background-color: var(--sub-color);
    }
  }
}
</style>
